import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { FiX, FiMenu, FiPhoneCall } from "react-icons/fi";


class HeaderKC extends Component {
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function () {
            console.log('All assets are loaded')
        })
    }


    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }

    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }


    render() {
        var elements = document.querySelectorAll('.has-droupdown > a');
        for (var i in elements) {
            if (elements.hasOwnProperty(i)) {
                elements[i].onclick = function () {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { logo, color = 'default-color' } = this.props;
        let logoUrl;
        if (logo === 'light') {
            logoUrl = <img src="/assets/images/logo/logo-light.png" alt="Digital Agency" />;
        } else if (logo === 'dark') {
            logoUrl = <img src="/assets/images/logo/logo-dark.png" alt="Digital Agency" />;
        } else if (logo === 'symbol-dark') {
            logoUrl = <img src="/assets/images/logo/logo-symbol-dark.png" alt="Digital Agency" />;
        } else if (logo === 'symbol-light') {
            logoUrl = <img src="/assets/images/logo/logo-symbol-light.png" alt="Digital Agency" />;
        } else {
            logoUrl = <img src="/assets/images/logo/kc-logo.png" className="kc-logo" alt="Kalwanu Constructions" />;
        }


        return (
            <header className={`header-area formobile-menu header--transparent ${color}`}>
                <div className="header-wrapper" id="header-wrapper">
                    <div className="header-left">
                        <div className="logo">
                            <a href="/">
                                {logoUrl}
                            </a>
                        </div>
                    </div>
                    <div className="header-right header-right-kc">
                        <nav className="mainmenunav d-lg-block">
                            <ul className="mainmenu">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li>
                                    <Link to="/house-designs" >House Designs</Link>
                                </li>
                                <li>
                                    <Link to="/about-us" >About Us</Link>
                                </li>
                                <li>
                                    <Link to="/contact-us" >Contact Us</Link>
                                </li>
                            </ul>
                        </nav>
                        <div className="header-btn">
                            <div className="call-icon call-icon-kc">
                                <FiPhoneCall />
                            </div>
                            <a class="btn-transparent rn-btn-dark" href="tel:1300123456">
                                <span class="text">1800.960.101</span>
                            </a>
                            {/* <div className="states">
                                <ul>
                                    <li>
                                        NSW
                                    </li>
                                    <li>.</li>
                                    <li>
                                        VIC
                                    </li>
                                    <li>.</li>

                                    <li>
                                        ACT
                                    </li>
                                </ul>
                            </div> */}
                            {/* <a className="rn-button-style--2 btn-solid" href="https://themeforest.net/checkout/from_item/25457315?license=regular">
                                <span>Contact Us</span>
                            </a> */}
                        </div>
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default HeaderKC;